import { useEffect, useState } from "react";
import { api, apiErr } from "@/api";

export function useInterests(cid, enabled) {
  const [view, setView] = useState({ items: [], shared: false, unshared_count: 0 });
  useEffect(() => {
    if (!enabled || !cid) { return; }
    api.get(`/visitor/interests/${cid}`).then(({ data }) => setView(data)).catch(() => {});
  }, [cid, enabled]);

  const liked = new Set(view.items.map((i) => i.product_id));
  const toggle = async (pid) => {
    try { const { data } = await api.post(`/visitor/interests/${cid}/toggle`, { product_id: pid }); setView(data); }
    catch (err) { return apiErr(err); }
    return null;
  };
  const share = async () => {
    const { data } = await api.post(`/visitor/interests/${cid}/share`, { consent: true });
    setView(data);
  };
  return enabled ? { view, liked, toggle, share } : null;
}
